import CustomImage from 'components/shared/atoms/CustomImage/CustomImage';

export default async function resizedImage(base64image, paramWidth = 1080, paramHeight = 1080) {
    const img = await CustomImage(base64image);
    let width = paramWidth;
    let height = paramHeight;
    let base64ResizedImage;

    // Check if the image require resize at all
    if (img.height <= height && img.width <= width) {
        base64ResizedImage = base64image;
    } else {
        // Make sure the width and height preserve the original aspect ratio and adjust if needed
        if (img.height > img.width) {
            width = Math.floor(height * (img.width / img.height));
        } else {
            height = Math.floor(width * (img.height / img.width));
        }

        const resizingCanvas = document.createElement('canvas');
        const resizingCanvasContext = resizingCanvas.getContext('2d');

        // Start with original image size
        resizingCanvas.width = img.width;
        resizingCanvas.height = img.height;

        // Draw the original image on the (temp) resizing canvas
        resizingCanvasContext.drawImage(
            img,
            0,
            0,
            resizingCanvas.width,
            resizingCanvas.height
        );

        const curImageDimensions = {
            width: Math.floor(img.width),
            height: Math.floor(img.height)
        };

        // Now do final resize for the resizingCanvas to meet the dimension requirements
        // directly to the output canvas, that will output the final image
        const outputCanvas = document.createElement('canvas');
        const outputCanvasContext = outputCanvas.getContext('2d');

        outputCanvas.width = width;
        outputCanvas.height = height;

        outputCanvasContext.drawImage(
            resizingCanvas,
            0,
            0,
            curImageDimensions.width,
            curImageDimensions.height,
            0,
            0,
            width,
            height
        );

        // output the canvas pixels as an image. params: format, quality
        base64ResizedImage = outputCanvas.toDataURL('image/png', 0.85);
    }

    return base64ResizedImage;
}
